import React from 'react'
import TitleText from '../components/PageHeading'
import Content from '../components/Content'
import { useEffect } from 'react';
import ContactBanner from '../components/ContactBanner';

export default function Services() {

  useEffect(() => {
    document.title = "Tjänster";
  });

  const text = `Vi utför alla slags arbeten inom byggnadsplåt. Exempel på uppdrag är tätskikt, fasadarbeten, service, underhåll, renoveringar av tak samt taksäkerhet.
                Mindre snickeriarbeten samt även specialtillverkning/ montering och mindre svetsjobb kan utföras`;

  const text2 = "Tveka inte att höra av er om ni har frågor angående ert framtida projekt!";

  return (
    <>
      <TitleText title="Tjänster" />
      <ContactBanner />
      <Content text={[text,text2]}/>
      </>
      )
}